import type { GetAudienceAdminListQuery } from '~/services/PromoService';

export const audienceAdminQueryKeys = {
  all: ['audience-admin'] as const,
  lists: () => [...audienceAdminQueryKeys.all, 'list'] as const,
  list: (query: GetAudienceAdminListQuery) => [...audienceAdminQueryKeys.lists(), query] as const,
};
